export default __webpack_public_path__ + "static/lead-banner-425be30a5df06e99cffbfd75d9ec1d8b.jpg";